// Author THQ
// Date 2025-04-08 17:07:36

import * as model from "@/model/em/ppe/PpeApplyScrapDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.PpeApplyScrapDetail(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_PPE_URL,
    })
    .buildStore()
